
import type { GridValueFormatterParams } from "@mui/x-data-grid";

 const percentage = () => ({ value }: GridValueFormatterParams<string | number>) =>
    `${(Number(value) * 100) || 0}%`;

export default percentage;
